// extracted by mini-css-extract-plugin
var _1 = "RequestWizardFormModal-moduledisabledPointerEvents__i5AwZ";
export { _1 as "disabledPointerEvents" }
